import type { ChatSummary } from '../../composables/aiAgentContract';

/**
 * pickDefaultChat — return the id of the chat with the most recent createdAt.
 *
 * The API orders by `updated_at DESC` (plan D4), so `chats[0]` is NOT necessarily
 * the newest chat — we must compare `createdAt` explicitly. ISO 8601 strings
 * compare lexicographically, so a simple string comparison suffices.
 *
 * Returns null when the list is empty.
 */
export function pickDefaultChat(chats: ChatSummary[]): number | null {
  if (chats.length === 0) {
    return null;
  }

  let best = chats[0];
  for (let i = 1; i < chats.length; i++) {
    if (chats[i].createdAt > best.createdAt) {
      best = chats[i];
    }
  }

  return best.id;
}
